module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/CLASSICS-ARCHAEOLOGY-a57a241ec374d6bc8c66bc1110b8fb42.png";